<template lang="pug">
  .container.grid-lg
    .card.mt-2
      .card-header
        .text-bold Filtrar
      .card-body
        form-filter(@submit="fetchReport")
    .full-height.loading.loading-lg(v-if="loading")
    div(v-else-if="report")
      div(v-if=" report.length")
        .card.my-2.no-print
          .card-header
            .h5 Gráfico
          .card-body
            bar-chart(:data="chartData" :height="`${report.length * 50}px`")
        .card.my-2
          .card-header
            .h5 Tabela resumo
          .card-body
            table.table.table-striped
              thead
                tr
                  th {{ 'cadastro.zona' | tModel }}
                  th.text-right Quantidade
              tbody
                tr(v-for="item in report")
                  td {{ item.descricao ? `Zona ${item.descricao}` : 'Sem zona' }}
                  td.text-right {{ item.q }}
              tfoot.text-bold
                tr
                  td
                  td.text-right Total: {{ total }}
      .card.mt-2(v-else)
        .card-body
          .empty
            .empty-icon
              i.fa.fa-search.fa-4x
            p.empty-title.h5 Nada encontrado
            p.empty-subtitle Não foram encontradas OS-m neste período
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import ordemServicos from '@/api/indicadores/ordemServicos'
import FormFilter from './components/Filter'

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter },
  computed: {
    total() {
      return this.report.reduce((acc, item) => acc + Number(item.q), 0)
    },
    chartData() {
      return this.report.map(item => [
        item.descricao ? `Zona ${item.descricao}` : 'Sem zona',
        Number(item.q),
      ])
    },
  },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await ordemServicos.porZona({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchReport()
  },
}
</script>
